<template>
  <router-view/>
</template>

<script>
export default {
  computed: {

    userParams () {
      const user = this.$store.state.authentication.authorized

      if (!user || !user.id) return {}

      return {
        user_type: user.role
      }
    }
  },

  mounted () {
    // if (this.$intercom) {
    //   this.$intercom.boot(this.userParams)
    // }
  },

  watch: {
    // userParams () {
    //   if (this.$intercom) {
    //     this.$intercom.update(this.userParams)
    //   }
    // }
  }
}
</script>

<style lang="scss" >

html {

  .intercom-lightweight-app, .intercom-launcher-frame {
    z-index: 85 !important;
  }

  .intercom-launcher, .intercom-launcher-frame, .intercom-lightweight-app-launcher {
    bottom: 100px !important;
    right: 15px !important;
  }

  .intercom-launcher-badge-frame {
    bottom: 145px !important;
    right: 15px !important;
    z-index: 85 !important;
  }

  .intercom-messenger-frame {
    bottom: 175px !important;
  }

  .iubenda-tp-btn[data-tp-float][data-tp-float=bottom-right] {
    z-index: 85 !important;
    bottom: 175px !important;
    right: 15px !important;
    margin: 0 13px 0 0 !important;
  }

  .consent-unnecessary {
    .iubenda-tp-btn[data-tp-float][data-tp-float=bottom-right] {
      display: none !important;
    }
  }

}

</style>
